

















































































import Vue from 'vue'

import {
  QAQC,
  QAQCParameter,
  FindNormalData,
  QAQCNormalData,
  SaveNormalData,
} from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      qaqcId: 0,
      qaqc: { parameters: [] as QAQCParameter[] } as QAQC,
      fields: [] as string[],
      normals: [] as QAQCNormalData[],
      deleted: [] as number[],
    }
  },

  methods: {
    async findNormalData() {
      this.deleted = []
      this.fields = []
      const { qaqc, normalData } = await FindNormalData(this.qaqcId)
      this.normals = normalData
      this.qaqc = qaqc

      for (const parameter of qaqc.parameters) {
        if (parameter.name == 'id') {
          continue
        }
        this.fields.push(parameter.name)
      }
    },

    async saveNormalData() {
      await SaveNormalData(this.qaqcId, this.normals, this.fields, this.deleted)
    },

    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------
    onRowClick(qaqc: QAQC) {
      this.$router.push({
        path: `/cems/setting/qaqc/${qaqc.id}`,
      })
    },

    onFormSubmit(ev: Event) {
      ev.preventDefault()
    },

    onFormReset(ev: Event) {
      ev.preventDefault()
      this.$router.push('/cems/setting/qaqc')
    },

    addRow() {
      const normalData: QAQCNormalData = {}
      for (const field of this.fields) {
        normalData[field] = 0
      }

      this.normals.push(normalData)
    },
    onRowDelete(index: number) {
      const normal = this.normals[index]
      if (typeof normal.id == 'number' && normal.id != 0) {
        this.deleted.push(normal.id)
      }
      this.normals.splice(index, 1)
    },

    async onSave() {
      await this.saveNormalData()
      await this.findNormalData()
    },
  },

  async created() {
    this.qaqcId = parseInt(this.$route.params.qaqcId)
    await this.findNormalData()
  },
})
